import * as React from 'react';

const ButtonLoader = /*#__PURE__*/ React.memo(()=>/*#__PURE__*/ React.createElement("div", {
        "aria-hidden": "true",
        className: "button--loader"
    })
);

export { ButtonLoader as default };
//# sourceMappingURL=ButtonLoader.js.map
